import { resolveFileUrl } from '@/components/shared/utils/fileUrl'

function parseBodyJson(bodyJson) {
  if (!bodyJson) return null
  if (typeof bodyJson === 'object') return bodyJson
  try {
    return JSON.parse(bodyJson)
  } catch {
    return null
  }
}

function usableSrc(src) {
  if (!src || typeof src !== 'string') return ''
  const trimmed = src.trim()
  if (!trimmed || trimmed.startsWith('data:')) return ''
  return resolveFileUrl(trimmed)
}

function firstGallerySrc(attrs = {}) {
  const rows = Array.isArray(attrs.rows) ? attrs.rows : []
  for (const row of rows) {
    for (const item of row?.items || []) {
      const src = usableSrc(item?.src)
      if (src) return src
    }
  }
  return ''
}

function walkBodyJson(node) {
  if (!node || typeof node !== 'object') return ''

  const type = node.type
  if (type === 'image' || type === 'inlineImage') {
    return usableSrc(node.attrs?.src)
  }
  if (type === 'imageGallery') {
    return firstGallerySrc(node.attrs)
  }

  const children = node.content
  if (!Array.isArray(children)) return ''
  for (const child of children) {
    const found = walkBodyJson(child)
    if (found) return found
  }
  return ''
}

function extractFromHtml(html) {
  if (!html || typeof html !== 'string') return ''
  const match = html.match(/<img[^>]+src=["']([^"']+)["']/i)
  return usableSrc(match?.[1] || '')
}

/** 从正文 JSON / HTML 取第一张可用图片 URL */
export function extractFirstContentImage(bodyHtml, bodyJson) {
  const fromJson = walkBodyJson(parseBodyJson(bodyJson))
  if (fromJson) return fromJson
  return extractFromHtml(bodyHtml)
}
